// extracted by css-extract-rspack-plugin
export default {"root":"kWFpe9V7_kL7QVM6","open":"UmKeftrhYMEn1Eeu"};